import type { MedidasPagina, Pagina } from '@miolos/core';
import { BlocoImpresso, type ContextoBloco } from './BlocoImpresso';

/**
 * As caixas que o usuário posicionou à mão.
 *
 * O motor já decidiu o que cabe onde: aqui só se desenha. A camada tem o
 * tamanho exato da **área de conteúdo** da folha e cada caixa é posicionada em
 * milímetros a partir do canto dela — o mesmo referencial que o assistente usa
 * quando converte o arrasto da tela, e o mesmo que o PDF leva para o papel.
 *
 * `data-caixa` é o que o editor usa para encontrar cada caixa na prévia; por
 * isso a chave fica no DOM, e não só no desenho.
 */
export function CaixasLivresImpressas({
  pagina,
  medidas,
  ctx,
}: {
  pagina: Pagina;
  medidas: MedidasPagina;
  ctx: ContextoBloco;
}) {
  const caixas = pagina.caixasLivres;
  if (!caixas || caixas.length === 0) return null;

  return (
    <div
      data-camada="caixas-livres"
      style={{
        position: 'absolute',
        left: `${medidas.conteudoXMm}mm`,
        top: `${medidas.conteudoYMm}mm`,
        width: `${medidas.larguraConteudoMm}mm`,
        height: `${medidas.alturaConteudoMm}mm`,
        zIndex: 1100,
        pointerEvents: 'none',
      }}
    >
      {caixas.map((caixa) => (
        <div
          key={caixa.chave}
          data-caixa={caixa.chave}
          style={{
            position: 'absolute',
            left: `${caixa.xMm}mm`,
            top: `${caixa.yMm}mm`,
            width: `${caixa.larguraMm}mm`,
            height: `${caixa.alturaMm}mm`,
            /*
             * A caixa nunca deixa o conteúdo escapar: o motor já avisou quando o
             * conteúdo pede mais altura do que ela tem, e o que passa é cortado
             * aqui — em silêncio, como em toda seção. É o preço de o usuário
             * mandar na posição.
             */
            overflow: 'hidden',
          }}
        >
          <BlocoImpresso bloco={caixa.bloco} ctx={ctx} />
        </div>
      ))}
    </div>
  );
}
